import styled from "styled-components";
import Check from "~/componentes/CustomForm/Check";
import CheckWrapper from "~/componentes/CustomForm/CheckWrapper";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.5rem;

  .Acoordion_title_p {
    text-align: left;
    margin-bottom: -0.25rem;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1.8rem;
    margin-bottom: 0.3rem;
    color: ${Colors.Color7};
  }

  ${(props) => props.minimizable && `position: relative;`}

  .Acoordion_Button_minimizable {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    border: none;
    background: inherit;

    i.green {
      color: #4fa754;
    }

    i.red {
      color: #ff4031;
    }
  }
`;

export const AcessosContent = styled(CheckWrapper)`
  background: ${Colors.Color13};
  border-radius: 0.5rem;
`;

export const BoxContainer = styled.div`
  margin: -0.1rem 0rem 0.5rem 0rem;


`;

export const ModuloDiv = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  padding: 0.3rem;
  cursor: pointer;
  border-radius: 0.5rem;
  background: ${Colors.Color23};

  .Acessos_Box_selecionados_icon_div {
    display: flex;

    i,
    p {
      align-self: center;
      height: fit-content;
    }

    p {
      color: ${Colors.Color7};
      margin-right: 0.8rem;
      font-size: 0.75rem;
      line-height: normal;
    }
  }
`;

export const CheckBoxLabel = styled.label`
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;

  h6 {
    margin-left: 0.4rem;
    text-align: left;
    font-weight: 400;
    font-size: 0.75rem;
    color: ${props => {
      if (props.subItem === true) return Colors.Color7;
      else return Colors.Color7;
    }};
  }
`;

export const MenusDiv = styled.div`
  list-style: none;
  padding: 0 0 0 1.625rem;

  .subItem {
    margin: 0.75rem 0;
  }
`;

export const CheckBox = styled(Check)`
  margin: 0 0.75em 0 0;
  appearance: none;
  width: 1.25rem;
  height: 1.25rem;
  background: #d0d7db;
  border-radius: 0.125rem;
  transition: 0.3s ease;
  outline: none;
  border: none;
  box-shadow: none;
  position: relative;

  :hover {
    box-shadow: none;
  }

  :checked {
    background: #1ca9d0;
  }
  :checked ~ h6 {
    color: #293f57;
  }

  ::before {
    position: absolute;
    content: "";
    width: 0.875rem;
    height: 0.125rem;
    background: #fff;
    -webkit-transform: rotate(-50deg);
    -ms-transform: rotate(-50deg);
    transform: rotate(-50deg);
    top: 0.563rem;
    left: 0.313rem;
    transition: 0.3s ease;
    opacity: 0;
  }
  ::after {
    position: absolute;
    content: "";
    width: 0.375rem;
    height: 0.125rem;
    background: #fff;
    -webkit-transform: rotate(50deg);
    -ms-transform: rotate(50deg);
    transform: rotate(50deg);
    top: 0.689rem;
    left: 0.188rem;
    transition: 0.3s ease;
    opacity: 0;
  }

  :checked::before,
  :checked::after {
    opacity: 1;
  }

  :disabled {
    background: #dedede;
    color: #ffffff;
    border: none;
  }
`;
